import { render, staticRenderFns } from "./StatsKpiColumnToday.vue?vue&type=template&id=4fd16279&scoped=true&"
import script from "./StatsKpiColumnToday.vue?vue&type=script&lang=js&"
export * from "./StatsKpiColumnToday.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiColumnToday.vue?vue&type=style&index=0&id=4fd16279&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd16279",
  null
  
)

export default component.exports